import React from "react";
import makeStyles from '@mui/styles/makeStyles';
// @mui/icons-material
// import  from "@mui/icons-material/";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import Muted from "components/Typography/Muted.js";
import PhoneIcon from '@mui/icons-material/Phone';
import BusinessIcon from '@mui/icons-material/Business';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import BuildIcon from '@mui/icons-material/Build';
import Icon from '@mui/material/Icon';
import ListAltIcon from '@mui/icons-material/ListAlt';



import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

import teamsStyle from "styles/jss/nextjs-material-kit-pro/pages/sectionsSections/teamsStyle.js";
//import tribalismStyles from "styles/jss/nextjs-material-kit-pro/tribalismStyles.js";
import tribalismStyles from "styles/jss/nextjs-material-kit-pro/tooltipsStyle.js";

const useStyles = makeStyles(teamsStyle);

export default function SectionTeams({ ...rest }) {
  const classes = useStyles();
  return (
    <div className="cd-section" {...rest}>


      {/* B2B Clients Start */}
      <div
      className="clients"
        //className={classes.team + " " + classes.section}
        //style={{ backgroundImage: "url('/img/examples/city.jpg')" }}
        //style={{ backgroundColor: "white"}}
      >
        <div className={classes.container} style = {{padding: "0.3rem"}}>


          <Card style={{marginTop:"0.75rem",marginBottom:"0.75rem"}}>
            <GridContainer alignItems="center" style = {{margin:"0px"}} >
              <GridItem xs={3} sm={3} md={3} lg={3}  style={{ padding : "0.3rem" ,textAlign:"center", alignItems:"center"}} >

                <PhoneIcon style={{ color: "#e91e63",fontSize: "3.0rem"}} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style = {{padding : "0.3rem"}} >
                <CardContent style = {{padding:"0rem"}}>
                <Typography gutterBottom  component="h6">
                  1. Get in contact - phone/email
                </Typography>
                <Typography variant="caption" color="textSecondary" >
                  We will contact you, topline understand what business you are and discuss very high level work and costs
                </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

        
          <Card style={{marginTop:"0.75rem",marginBottom:"0.75rem"}}>
            <GridContainer alignItems="center" style = {{margin:"0px"}} >
              <GridItem xs={3} sm={3} md={3} lg={3} style={{padding : "0.3rem", textAlign:"center", alignItems:"center"}} >
                
                <BusinessIcon style={{ color: "#e91e63",fontSize: "3.0rem"}} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style = {{padding : "0.3rem"}} >
                <CardContent style = {{padding:"0rem"}}>
                <Typography gutterBottom  component="h6">
                  2. Assess your business Situation
                  </Typography>
                  <Typography variant="caption" color="textSecondary" >
                  We can begin generating a proposal in a few hours! We may need access to Google Analytics & similar platforms.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

          <Card style={{marginTop:"0.75rem",marginBottom:"0.75rem"}}>
            <GridContainer alignItems="center" style = {{margin:"0px"}} >
              <GridItem xs={3} sm={3} md={3} lg={3} style={{padding : "0.3rem", textAlign:"center", alignItems:"center"}} >
                
                <PriorityHighIcon style={{ color: "#e91e63",fontSize: "3.0rem"}} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style = {{padding : "0.3rem"}} >
                <CardContent style = {{padding:"0rem"}}>
                <Typography gutterBottom  component="h6">
                  3. We'll recommend priorities
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                   We'll send you a "to the point" proposal and schedule a call where necessary. Work is either project or retainer based.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

          <Card style={{marginTop:"0.75rem",marginBottom:"0.75rem"}}>
            <GridContainer alignItems="center" style = {{margin:"0px"}} >
              <GridItem xs={3} sm={3} md={3} lg={3} style={{padding : "0.3rem", textAlign:"center", alignItems:"center"}} >
                
                <BuildIcon style={{ color: "#e91e63",fontSize: "3.0rem"}} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style = {{padding : "0.3rem"}} >
                <CardContent style = {{padding:"0rem"}}>
                <Typography gutterBottom  component="h6">
                  4. Implementation
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                   We'll need access to your site. We'll establish quick comms via Slack, Trello and similar channels during this period.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>

          <Card style={{marginTop:"0.75rem",marginBottom:"0.75rem"}}>
            <GridContainer  alignItems="center" style = {{margin:"0px"}} >
            <GridItem xs={3} sm={3} md={3} lg={3} style={{padding : "0.3rem", textAlign:"center", alignItems:"center"}} >
                
                <ListAltIcon style={{ color: "#e91e63",fontSize: "3.0rem"}} />
              </GridItem>
              <GridItem xs={9} sm={9} md={9} lg={9} style = {{padding : "0.3rem"}} >
                <CardContent style = {{padding:"0rem"}}>
                <Typography gutterBottom  component="h6">
                  5. Results
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                   We'll have a review meeting (or a regular meeting for retainer projects) and tidy everythign off.
                  </Typography>
                </CardContent>
              </GridItem>
            </GridContainer>
          </Card>
          
          
          

        </div>

        <br />
        {/* B2B Clients END */}
      </div>

      
    </div>
  );
}
